module.exports = __webpack_public_path__ + "static/media/red-number-9.8c959598.png";